module.exports = new __parcel__URL__("training-platform-screenshot.a3b0cf9b.png").toString();